import { useQuery } from '@apollo/client';

import query from './query.graphql';

export default function useOnboardingStatus() {
  const { data = {}, loading, refetch } = useQuery(query);

  const hasConnectors = data?.account?.connectors.length > 0;
  const hasTagsTraffic = Boolean(
    data?.account?.accountSetting?.firstPageEventReceivedAt,
  );
  const hasSkippedOnboarding = Boolean(
    data?.account?.accountSetting?.onboardingSkipped,
  );

  const shouldOnboard =
    (!hasConnectors || !hasTagsTraffic) && !hasSkippedOnboarding && !loading;

  return {
    refetch,
    loading,
    hasConnectors,
    hasTagsTraffic,
    hasSkippedOnboarding,
    shouldOnboard,
  };
}
